export enum BeachVolleyballCardsAttributeIds {
  YellowCard = 521,
  RedCard = 522,
}
